// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import config from "./config/appConfig";

const firebaseConfig = {
	apiKey           : config.firebase.apiKey,
	authDomain       : config.firebase.authDomain,
	projectId        : config.firebase.projectId,
	storageBucket    : config.firebase.storageBucket,
	messagingSenderId: config.firebase.messagingSenderId,
	appId            : config.firebase.appId,
	measurementId    : config.firebase.measurementId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth with persistence
export const auth = getAuth(app);

// Set persistence to LOCAL (survives page refresh and browser restart)
setPersistence(auth, browserLocalPersistence).catch(error => {

	console.error("Failed to set auth persistence:", error);

});

export default app;